import React, {FC} from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import Nav from "./components/Navbar";
import {Outlet, Route, Routes} from "react-router-dom";
import Home from "./tabs/home/Home";
import ProtectedRoute from "./utils/ProtectedRoute";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import {routes} from "./app/routes";
import Login from "./tabs/login/Login";
import CreateRequest from "./tabs/request/new/CreateRequest";
import RequestList from "./tabs/request/RequestList";
import {ToastContainer} from "react-toastify";
import SubmittedNewRequest from "./tabs/request/new/SubmittedNewRequest";
import Response from "./tabs/request/new/Response";

const App: FC = () => {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <CreateRequest/>
                    }
                />
                <Route
                    path={`/${routes.SUBMITTED}`}
                    element={
                        <SubmittedNewRequest/>
                    }
                />
                <Route
                    path={`/${routes.RESPONSE}`}
                    element={
                        <Response/>
                    }
                />
                <Route
                    path={`/${routes.LOGIN}`}
                    element={
                        <Login/>
                    }
                />
                <Route path={`/${routes.ADMIN}`} element={<ProtectedRoute>
                    <Nav/>
                    <Outlet/>
                </ProtectedRoute>}>
                    <Route
                        path=""
                        element={
                            <ProtectedRoute>
                                <Home/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={`${routes.REQUESTS}`}
                        element={
                            <ProtectedRoute>
                                <RequestList/>
                            </ProtectedRoute>
                        }
                    />

                </Route>
            </Routes>
            <ToastContainer/>
        </>
    );
};

export default App;
